import YellowTheme from './allPresets/Yellow/yellow'
import PIQGreenTheme from './allPresets/PIQGreen/PIQGreen'

export default {
  YellowTheme,
  PIQGreenTheme
}
